import "./DadosBancarios.css";

const DadosBancarios = ({
  DadosBancarios: upperProps,
  dadosBancarios: lowerProps,
}) => {
  const data = lowerProps ?? upperProps ?? {};

  const toStr = (v) => ((v ?? v === 0) ? String(v) : "");

  return (
    <div className="card shadow-sm p-4 mb-4 dados-bancarios">
      <h5 className="fw-bold text-uppercase mb-4">
        Dados Bancários do Sindicato
      </h5>

      <div className="row">
        <div className="col-md-3 mb-3">
          <label className="form-label fw-semibold">Tipo de Conta</label>
          <input
            type="text"
            className="form-control"
            value={toStr(data?.tipoContaDescricao)}
            readOnly
          />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label fw-semibold">Banco</label>
          <input
            type="text"
            className="form-control"
            value={toStr(data?.banco)}
            readOnly
          />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label fw-semibold">Agência</label>
          <input
            type="text"
            className="form-control"
            value={toStr(data?.agencia)}
            readOnly
          />
        </div>

        <div className="col-md-3 mb-3">
          <label className="form-label fw-semibold">Conta</label>
          <input
            type="text"
            className="form-control"
            value={toStr(data?.conta)}
            readOnly
          />
        </div>
      </div>

      <p className="text-muted small mt-2">
        Caso necessário alteração dos dados, favor entrar com contato com a
        Superintendência de Desenvolvimento Sindical.
      </p>
    </div>
  );
};

export default DadosBancarios;
